import { useEffect, useState } from 'react';
import { restaurantInfo } from '../../../mocks/restaurant';

const HeaderSection = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'お料理', href: '#menu' },
    { label: '空間・サービス', href: '#space' },
    { label: 'アクセス', href: '#access' },
    { label: 'ご予約・お問い合わせ', href: '#contact' },
  ];

  const handleNavClick = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-cream-warm shadow-sm border-b border-brown-dark/10' : 'bg-transparent'
      }`}
    >
      <div className="max-w-6xl mx-auto px-5 md:px-10 py-3 flex items-center justify-between gap-4">
        {/* Logo */}
        <a href="#top" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }} className="flex items-center gap-3 cursor-pointer">
          <div className="w-10 h-10 flex items-center justify-center">
            <img
              src="https://public.readdy.ai/ai/img_res/107b6f22-c7a6-4dc8-acf9-6e009091b8de.png"
              alt="ASIAN KITCHEN BALEN ロゴ"
              className="w-10 h-10 object-contain"
            />
          </div>
          <div>
            <p className={`font-serif-jp font-bold text-sm tracking-widest leading-tight transition-colors duration-300 ${scrolled ? 'text-brown-dark' : 'text-white'}`}>
              ASIAN KITCHEN
            </p>
            <p className={`font-serif-jp font-bold text-lg tracking-[0.25em] leading-tight transition-colors duration-300 ${scrolled ? 'text-teal-deep' : 'text-white'}`}>
              BALEN
            </p>
          </div>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
              className={`font-sans-jp text-xs tracking-wider transition-colors duration-300 cursor-pointer whitespace-nowrap hover:text-orange-sunset ${
                scrolled ? 'text-brown-dark' : 'text-white/90'
              }`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        {/* Hours badge (desktop) */}
        <div className={`hidden lg:flex items-center gap-2 text-xs font-sans-jp transition-colors duration-300 ${scrolled ? 'text-brown-mid' : 'text-white/80'}`}>
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-time-line text-sm" />
          </div>
          <span>11:00〜22:00 / 火曜定休</span>
        </div>

        {/* Hamburger (mobile) */}
        <button
          className={`md:hidden w-8 h-8 flex items-center justify-center cursor-pointer ${scrolled ? 'text-brown-dark' : 'text-white'}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="メニューを開く"
        >
          <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'}`} />
        </button>
      </div>

      {/* Mobile Menu Drawer */}
      {menuOpen && (
        <div className="md:hidden bg-cream-warm border-t border-brown-dark/10">
          <div className="px-5 py-4 flex flex-col gap-4">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                className="font-sans-jp text-sm text-brown-dark tracking-wider py-1 border-b border-brown-dark/10 cursor-pointer hover:text-teal-deep transition-colors"
              >
                {link.label}
              </a>
            ))}
            <p className="font-sans-jp text-xs text-brown-mid pt-1">
              <i className="ri-time-line mr-1" />
              11:00〜22:00 / 火曜定休
            </p>
          </div>
        </div>
      )}
    </header>
  );
};

export default HeaderSection;
